import { createContext, useContext } from 'react'
import type { User } from 'firebase/auth'
import type { PlayerProfile, PlayerProfileInput } from './playerProfile'

export type PlayerContextValue = {
  user: User | null
  profile: PlayerProfile | null
  profileLoading: boolean
  loading: boolean
  available: boolean
  error: string
  signInWithGoogle: () => Promise<void>
  continueAsGuest: () => Promise<void>
  signOutPlayer: () => Promise<void>
  saveProfile: (profile: PlayerProfileInput) => Promise<void>
  clearError: () => void
}

export const PlayerContext = createContext<PlayerContextValue | null>(null)

export function usePlayer() {
  const context = useContext(PlayerContext)
  if (!context) throw new Error('usePlayer must be used inside AuthProvider')
  return context
}
